<template>
  <div class="login-success">
    <div class="loader" v-if="loading">
      <font-awesome-icon icon="spinner" spin size="3x" />
      <p>Weiterleitung...</p>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { showSuccess, showError } from '@/services/notification'
import api from '@/api/api'
import { storeToRefs } from 'pinia'

const router = useRouter()
const authStore = useAuthStore()
const { localTokens, isAuthenticated } = storeToRefs(authStore)
const loading = ref(true)
const error = ref(null)

onMounted(async () => {
  try {
    const queryParams = new URLSearchParams(window.location.search)
    const access_token = queryParams.get('access_token')
    const refresh_token = queryParams.get('refresh_token')
    const refresh_token_expires_in = queryParams.get('refresh_token_expires_in')
    const access_token_expires_in = queryParams.get('access_token_expires_in')
    const method = queryParams.get('method')
    const magicLink = queryParams.get('magic-link')
    const magicLinkEmail = queryParams.get('magic-link-email')

    if (method === 'magic-link') {
      if (magicLinkEmail) {
        loading.value = false
        showSuccess('Wenn ein Konto mit dieser E-Mail-Adresse existiert, wurde ein Magic Link versendet. Bitte überprüfe dein E-Mail-Postfach und klicke auf den Link, um dich anzumelden.')
        return
      }
    }
    if (magicLink) {
      await handleMagicLinkLogin(magicLink)
      return
    }
    if (access_token && refresh_token) {
      await handleTokenLogin(
        access_token,
        refresh_token,
        refresh_token_expires_in,
        access_token_expires_in,
      )
      return
    } else {
      throw new Error('Keine Token in der URL gefunden')
    }
  } catch (err) {
    console.error('Fehler bei der Anmeldung:', err)
  showError(err.message || 'Anmeldefehler, bitte versuch es erneut')
    loading.value = false
  }
})

const handleMagicLinkLogin = async (magicLink) => {
  try {
    loading.value = true
    error.value = null

    const response = await api.post('/auth/magic-link/callback', { token: magicLink })

    if (response.data && response.data.access_token && response.data.refresh_token) {
      const now = Date.now()
      localTokens.value = {
        access_token: response.data.access_token,
        refresh_token: response.data.refresh_token,
        access_token_expires_in: now + Number(response.data.access_token_expires_in) * 1000,
        refresh_token_expires_in: now + Number(response.data.refresh_token_expires_in) * 1000,
      }
      isAuthenticated.value = true
      await authStore.updateProfile()
      window.history.replaceState({}, document.title, window.location.pathname)
      router.replace('/')
    } else {
      throw new Error('Ungültige Antwort vom Server')
    }
  } catch (err) {
    console.error('Fehler bei der Magic-Link-Anmeldung:', err)
    showError(err.response?.data?.message || 'Ungültiger oder abgelaufener Magic Link')
    loading.value = false
  }
}

const handleTokenLogin = async (
  access_token,
  refresh_token,
  refresh_token_expires_in,
  access_token_expires_in,
) => {
  try {

    const now = Date.now()

    localTokens.value = {
      access_token: access_token,
      refresh_token: refresh_token,
      access_token_expires_in: now + Number(access_token_expires_in) * 1000,
      refresh_token_expires_in: now + Number(refresh_token_expires_in) * 1000,
    }

    isAuthenticated.value = true

    await authStore.updateProfile()

    window.history.replaceState({}, document.title, window.location.pathname)

    router.replace('/')
  } catch (err) {
    console.error('Fehler bei der Anmeldung:', err)
  showError(err.message || 'Anmeldefehler, bitte versuch es erneut')
    loading.value = false
  }
}
</script>
